var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHubspot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "125px",
    height: "130.9px",
    viewBox: "0 0 125 130.9",
    style: {
      enableBackground: "new 0 0 125 130.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FF7A59;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M124.3,69.9c-2.9-14-14.2-24.7-28.3-26.8V27.5c4.2-2,6.9-6.2,6.9-10.8v-0.4c0-6.6-5.4-12-12-12h-0.4 c-6.6,0-12,5.4-12,12v0.4c0,4.6,2.7,8.9,6.9,10.8v15.6C79.5,44,74,46.4,69.3,50.2L26.6,16.9c0.3-1.1,0.5-2.2,0.5-3.4 C27.1,6.1,21,0,13.5,0C6.1,0,0,6,0,13.5C0,21,6,27,13.5,27c0,0,0,0,0,0c2.3,0,4.6-0.6,6.7-1.8L62.2,58c-7.7,11.7-7.5,26.9,0.5,38.4 L50,109.2c-1-0.3-2.1-0.5-3.2-0.5c-6.1,0-11.1,5-11.1,11.1c0,6.1,5,11.1,11.1,11.1c6.1,0,11.1-5,11.1-11.1c0-1.1-0.2-2.2-0.5-3.2 L70,103.9c11.3,8.7,26.9,9.5,39,1.9C121.1,98.2,127.2,83.9,124.3,69.9z M90.7,94.3L90.7,94.3c-9.7,0.3-17.7-7.4-18-17 c-0.3-9.7,7.4-17.7,17-18c0.3,0,0.6,0,0.9,0c9.4,0.3,16.9,8.1,16.9,17.5C107.6,86.2,100.2,94,90.7,94.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHubspot);
export default __webpack_public_path__ + "static/media/icon-hubspot.ebf405852b8b7ece557dff25cc3bd3ad.svg";
export { ForwardRef as ReactComponent };